import axios from 'axios';

axios.defaults.headers.common['X-CSRF-TOKEN'] = document.cookie.split("=")[1];

//const baseUrl = 'http://localhost:4810/Api';

export default {




    //********************************************************************| Authintecations |***********************************************************

    login(bodyObjeect) {
        return axios.post(`/Security/login`, bodyObjeect);
    },

    IsLoggedin() {
        return axios.get(`/Security/IsLoggedin`);
    },

    Logout() {
        return axios.post(`/Security/Logout`);
    },








    // ********************************| Start Dictionaries |******************************


    // Types
    GetTypes(pageNo, pageSize, Search) {
        return axios.get(`api/admin/Dictionaries/Types/Get?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}`);
    },

    GetAllTypes() {
        return axios.get(`api/admin/Dictionaries/Types/GetAll`);
    },

    AddTypes(bodyObject) {
        return axios.post(`api/admin/Dictionaries/Types/Add`, bodyObject);
    },

    EditTypes(bodyObject) {
        return axios.post(`api/admin/Dictionaries/Types/Edit`, bodyObject);
    },

    DeleteTypes(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/Types/Delete`);
    },

    ChangeStatusTypes(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/Types/ChangeStatus`);
    },











    // InstitutionsTypes
    GetInstitutionsTypes(pageNo, pageSize, Search) {
        return axios.get(`api/admin/Dictionaries/InstitutionsTypes/Get?pageno=${pageNo}&pagesize=${pageSize}
        &Search=${Search}`);
    },

    GetAllInstitutionsTypes(Id) {
        return axios.get(`api/admin/Dictionaries/InstitutionsTypes/GetAll?TypesId=${Id}`);
    },

    AddInstitutionsTypes(bodyObject) {
        return axios.post(`api/admin/Dictionaries/InstitutionsTypes/Add`, bodyObject);
    },

    EditInstitutionsTypes(bodyObject) {
        return axios.post(`api/admin/Dictionaries/InstitutionsTypes/Edit`, bodyObject);
    },

    DeleteInstitutionsTypes(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/InstitutionsTypes/Delete`);
    },

    ChangeStatusInstitutionsTypes(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/InstitutionsTypes/ChangeStatus`);
    },






    // InstitutionsServiceValue
    GetInstitutionsServiceValue(pageNo, pageSize, Search) {
        return axios.get(`api/admin/Dictionaries/InstitutionsServiceValue/Get?pageno=${pageNo}&pagesize=${pageSize}
        &Search=${Search}`);
    },

    GetAllInstitutionsServiceValue(Id) {
        return axios.get(`api/admin/Dictionaries/InstitutionsServiceValue/GetAll?InstitutionsTypesId=${Id}`);
    },

    AddInstitutionsServiceValue(bodyObject) {
        return axios.post(`api/admin/Dictionaries/InstitutionsServiceValue/Add`, bodyObject);
    },

    EditInstitutionsServiceValue(bodyObject) {
        return axios.post(`api/admin/Dictionaries/InstitutionsServiceValue/Edit`, bodyObject);
    },

    DeleteInstitutionsServiceValue(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/InstitutionsServiceValue/Delete`);
    },

    ChangeStatusInstitutionsServiceValue(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/InstitutionsServiceValue/ChangeStatus`);
    },









    GetDashboardInfo() {
        return axios.get(`api/admin/Dictionaries/Dashboard/Get`);
    },



    // ********************************| End Dictionaries |********************************
























    // ********************************| Institutions |************************************

    GetInstitutions(pageNo, pageSize, Search) {
        return axios.get(`api/admin/Institutions/Get?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}`);
    },

    AddInstitutions(bodyObject) {
        return axios.post(`api/admin/Institutions/Add`, bodyObject);
    },

    EditInstitutions(bodyObject) {
        return axios.post(`api/admin/Institutions/Edit`, bodyObject);
    },

    DeleteInstitutions(Id) {
        return axios.post(`api/admin/Institutions/${Id}/Delete`);
    },

    ChangeStatusInstitutions(Id) {
        return axios.post(`api/admin/Institutions/${Id}/ChangeStatus`);
    },

    ChangeSalesStatusInstitutions(Id) {
        return axios.post(`api/admin/Institutions/${Id}/ChangeSalesStatus`);
    },

    CloseInstitutions(Id) {
        return axios.post(`api/admin/Institutions/${Id}/Close`);
    },




    //Closed Course
    GetClosedInstitutions(pageNo, pageSize, Search, IsFree, IsDiscount) {
        return axios.get(`api/admin/Institutions/GetClosed?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}
            &IsFree=${IsFree}&IsDiscount=${IsDiscount}`);
    },

    OpenInstitutions(Id) {
        return axios.post(`api/admin/Institutions/${Id}/Open`);
    },


    //ChartInfo
    GetAllInstitutionsChartInfo() {
        return axios.get(`api/admin/Institutions/Chart/GetAll`);
    },


    //ChartInfo
    GetInstitutionsChartInfo(Id) {
        return axios.get(`api/admin/Institutions/Chart/Get?Id=${Id}`);
    },


   





    //InstitutionsOrders
    GetInstitutionsOrders(Id, Search) {
        return axios.get(`api/admin/Institutions/InstitutionsOrders/Get?Id=${Id}&Search=${Search}`);
    },

    GetAllInstitutionsOrders(Id) {
        return axios.get(`api/admin/Institutions/InstitutionsOrders/GetAll?CourseId=${Id}`);
    },

    AddInstitutionsOrders(bodyObject) {
        return axios.post(`api/admin/Institutions/InstitutionsOrders/Add`, bodyObject);
    },

    EditInstitutionsOrders(bodyObject) {
        return axios.post(`api/admin/Institutions/InstitutionsOrders/Edit`, bodyObject);
    },

    DeleteInstitutionsOrders(Id) {
        return axios.post(`api/admin/Institutions/${Id}/InstitutionsOrders/Delete`);
    },

    ChangeStatusInstitutionsOrders(Id) {
        return axios.post(`api/admin/Institutions/${Id}/InstitutionsOrders/ChangeStatus`);
    },



    //InstitutionsPayments
    GetInstitutionsPayments(Id, Search) {
        return axios.get(`api/admin/Institutions/InstitutionsPayments/Get?Id=${Id}&Search=${Search}`);
    },

    GetAllRemindValue(Id) {
        return axios.get(`api/admin/Institutions/InstitutionsPayments/GetRemindValue?InstitutionsId=${Id}`);
    },

    AddInstitutionsPayments(bodyObject) {
        return axios.post(`api/admin/Institutions/InstitutionsPayments/Add`, bodyObject);
    },

    DeleteInstitutionsPayments(Id) {
        return axios.post(`api/admin/Institutions/${Id}/InstitutionsPayments/Delete`);
    },







    //Lectures
    GetCourseLectures(CourseId,ShapterId, Search) {
        return axios.get(`api/admin/Institutions/Lectures/Get?CourseId=${CourseId}&ShapterId=${ShapterId}&Search=${Search}`);
    },

    AddLectures(bodyObject) {
        return axios.post(`api/admin/Institutions/Lectures/Add`, bodyObject);
    },

    EditLectures(bodyObject) {
        return axios.post(`api/admin/Institutions/Lectures/Edit`, bodyObject);
    },

    DeleteLectures(Id) {
        return axios.post(`api/admin/Institutions/${Id}/Lectures/Delete`);
    },

    ChangeStatusLectures(Id) {
        return axios.post(`api/admin/Institutions/${Id}/Lectures/ChangeStatus`);
    },






    //LecturesAttashments
    GetCourseLecturesAttashments(LectureId, Search) {
        return axios.get(`api/admin/Institutions/LecturesAttashments/Get?LectureId=${LectureId}&Search=${Search}`);
    },

    AddLecturesAttashments(bodyObject) {
        return axios.post(`api/admin/Institutions/LecturesAttashments/Add`, bodyObject);
    },

    EditLecturesAttashments(bodyObject) {
        return axios.post(`api/admin/Institutions/LecturesAttashments/Edit`, bodyObject);
    },

    DeleteLecturesAttashments(Id) {
        return axios.post(`api/admin/Institutions/${Id}/LecturesAttashments/Delete`);
    },

    ChangeStatusLecturesAttashments(Id) {
        return axios.post(`api/admin/Institutions/${Id}/LecturesAttashments/ChangeStatus`);
    },






    //Exams
    GetCourseExams(CourseId,ShapterId, Search) {
        return axios.get(`api/admin/Institutions/Exams/Get?CourseId=${CourseId}&ShapterId=${ShapterId}&Search=${Search}`);
    },

    AddExams(bodyObject) {
        return axios.post(`api/admin/Institutions/Exams/Add`, bodyObject);
    },

    EditExams(bodyObject) {
        return axios.post(`api/admin/Institutions/Exams/Edit`, bodyObject);
    },

    DeleteExams(Id) {
        return axios.post(`api/admin/Institutions/${Id}/Exams/Delete`);
    },

    ChangeStatusExams(Id) {
        return axios.post(`api/admin/Institutions/${Id}/Exams/ChangeStatus`);
    },






    //ExamsQuestions
    GetCourseExamsQuestions(ExamId, Search) {
        return axios.get(`api/admin/Institutions/ExamsQuestions/Get?ExamId=${ExamId}&Search=${Search}`);
    },

    AddExamsQuestions(bodyObject) {
        return axios.post(`api/admin/Institutions/ExamsQuestions/Add`, bodyObject);
    },

    EditExamsQuestions(bodyObject) {
        return axios.post(`api/admin/Institutions/ExamsQuestions/Edit`, bodyObject);
    },

    DeleteExamsQuestions(Id) {
        return axios.post(`api/admin/Institutions/${Id}/ExamsQuestions/Delete`);
    },

    ChangeStatusExamsQuestions(Id) {
        return axios.post(`api/admin/Institutions/${Id}/ExamsQuestions/ChangeStatus`);
    },


    //Students
    GetInstitutionstudents(Id, Search) {
        return axios.get(`api/admin/Institutions/Students/Get?Id=${Id}&Search=${Search}`);
    },


    //Review
    GetCourseReview(Id, Search) {
        return axios.get(`api/admin/Institutions/Review/Get?Id=${Id}&Search=${Search}`);
    },





    //// ********************************| End Institutions |********************************















    //// ********************************| Students |********************************


    GetStudents(pageNo, pageSize, Search) {
        return axios.get(`api/admin/Students/Get?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}`);
    },

    AddStudents(bodyObject) {
        return axios.post(`api/admin/Students/Add`, bodyObject);
    },

    EditStudents(bodyObject) {
        return axios.post(`api/admin/Students/Edit`, bodyObject);
    },

    ChangeStatusStudents(Id) {
        return axios.post(`api/admin/Students/${Id}/ChangeStatus`);
    },

    ResetDeviceStudents(Id) {
        return axios.post(`api/admin/Students/${Id}/ResetDevice`);
    },

    ResetPasswordStudents(Id) {
        return axios.post(`api/admin/Students/${Id}/ResetPassword`);
    },

    DeleteStudents(Id) {
        return axios.post(`api/admin/Students/${Id}/Delete`);
    },

    //Suspends
    SuspendsStudents(bodyObject) {
        return axios.post(`api/admin/Students/Suspends/Add`, bodyObject);
    },

    GetSuspendsStudents(pageNo, pageSize, Search) {
        return axios.get(`api/admin/Students/Suspends/Get?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}`);
    },

    CanselSuspends(Id) {
        return axios.post(`api/admin/Students/${Id}/Suspends/Cansel`);
    },





    //ChangeRequest
    GetChangeRequest(pageNo, pageSize, Search) {
        return axios.get(`api/admin/Students/ChangeRequest/Get?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}`);
    },

    AcceptChangeRequest(Id) {
        return axios.post(`api/admin/Students/${Id}/ChangeRequest/Accept`);
    },

    AcceptAllChangeRequest() {
        return axios.post(`api/admin/Students/ChangeRequest/AcceptAll`);
    },

    RejectChangeRequest(Id) {
        return axios.post(`api/admin/Students/${Id}/ChangeRequest/Reject`);
    },

    DeleteChangeRequest(Id) {
        return axios.post(`api/admin/Students/${Id}/ChangeRequest/Delete`);
    },

    DeleteAllChangeRequest() {
        return axios.post(`api/admin/Students/ChangeRequest/DeleteAll`);
    },





    //InstitutionsRequests
    GetInstitutionsRequests(pageNo, pageSize, Search) {
        return axios.get(`api/admin/Students/InstitutionsRequests/Get?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}`);
    },

    AcceptInstitutionsRequests(Id) {
        return axios.post(`api/admin/Students/${Id}/InstitutionsRequests/Accept`);
    },

    RejectInstitutionsRequests(Id) {
        return axios.post(`api/admin/Students/${Id}/InstitutionsRequests/Reject`);
    },

    DeleteInstitutionsRequests(Id) {
        return axios.post(`api/admin/Students/${Id}/InstitutionsRequests/Delete`);
    },

    







    //Studetns Institutions
    GetStudentsInstitutions(Id, Search) {
        return axios.get(`api/admin/Students/Institutions/Get?Id=${Id}&Search=${Search}`);
    },

    AddStudentsInstitutions(bodyObject) {
        return axios.post(`api/admin/Students/Institutions/Add`, bodyObject);
    },

    AddStudentsInstitutionsValue(bodyObject) {
        return axios.post(`api/admin/Students/Institutions/AddValue`, bodyObject);
    },

    DropStudentsInstitutions(bodyObject) {
        return axios.post(`api/admin/Students/Institutions/Drop`, bodyObject);
    },







    //Wallet
    GetStudentsWallet(Id) {
        return axios.get(`api/admin/Students/Wallet/Get?Id=${Id}`);
    },

    AddStudentsWalletValue(bodyObject) {
        return axios.post(`api/admin/Students/Wallet/Charge`, bodyObject);
    },






    //Devices
    GetStudentsDevices(Id) {
        return axios.get(`api/admin/Students/Devices/Get?Id=${Id}`);
    },


    GetAllStudentsChartInfo() {
        return axios.get(`api/admin/Students/Chart/GetAll`);
    },



    //// ********************************| End Of Students |********************************













    // ********************************| Instructors |********************************



    GetInstructors(pageNo, pageSize, Search) {
        return axios.get(`api/admin/Instructors/Get?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}`);
    },

    GetAllInstructors() {
        return axios.get(`api/admin/Instructors/GetAll`);
    },

    AddInstructors(bodyObject) {
        return axios.post(`api/admin/Instructors/Add`, bodyObject);
    },

    EditInstructors(bodyObject) {
        return axios.post(`api/admin/Instructors/Edit`, bodyObject);
    },

    ChangeStatusInstructors(Id) {
        return axios.post(`api/admin/Instructors/${Id}/ChangeStatus`);
    },

    ResetDeviceInstructors(Id) {
        return axios.post(`api/admin/Instructors/${Id}/ResetDevice`);
    },

    ResetPasswordInstructors(Id) {
        return axios.post(`api/admin/Instructors/${Id}/ResetPassword`);
    },

    DeleteInstructors(Id) {
        return axios.post(`api/admin/Instructors/${Id}/Delete`);
    },

    //Suspends
    SuspendsInstructors(bodyObject) {
        return axios.post(`api/admin/Instructors/Suspends/Add`, bodyObject);
    },

    GetSuspendsInstructors(pageNo, pageSize, Search) {
        return axios.get(`api/admin/Instructors/Suspends/Get?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}`);
    },

    CanselInstructors(Id) {
        return axios.post(`api/admin/Instructors/${Id}/Suspends/Cansel`);
    },



    // ********************************| End Of Instructors |********************************












    // ********************************| Financial |********************************

    GetSubscriptions(pageNo, pageSize, Search, From, To) {
        return axios.get(`api/admin/Financial/GetSubscriptions?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}
        &From=${From}&To=${To}`);
    },

    GetRecharge(pageNo, pageSize, Search, From, To, UserId, DistributorsId, PaymentMethodId) {
        return axios.get(`api/admin/Financial/GetRecharge?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}
        &From=${From}&To=${To}&UserId=${UserId}&DistributorsId=${DistributorsId}&PaymentMethodId=${PaymentMethodId}`);
    },

    GetWalletTracker(pageNo, pageSize, Search, From, To, ProcessType, Channel) {
        return axios.get(`api/admin/Financial/GetWalletTracker?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}
        &From=${From}&To=${To}&ProcessType=${ProcessType}&Channel=${Channel}`);
    },





    // ********************************| End Of Financial |********************************














    // ********************************| VoucherCards |********************************

    GetVoucherCards(pageNo, pageSize, Search, DistributorsId) {
        return axios.get(`api/admin/VoucherCards/Get?pageNo=${pageNo}&pagesize=${pageSize}&Search=${Search}&DistributorsId=${DistributorsId}`);
    },

    AddVoucherCards(bodyObject) {
        return axios.post('api/admin/VoucherCards/Add', bodyObject);
    },

    SaleVoucherCards(Id) {
        return axios.post(`api/admin/VoucherCards/${Id}/Sale`, { responseType: 'blob' });
    },

    ForzePackage(Id) {
        return axios.post(`api/admin/VoucherCards/${Id}/Freeze`, { responseType: 'blob' });
    },

    DeletePackage(Id) {
        return axios.post(`api/admin/VoucherCards/${Id}/Delete`);
    },



    //Card
    GetCards() {
        return axios.get(`api/admin/VoucherCards/Cards/Get`);
    },

    GetCardInfoBySerialNumber(SerialNumber) {
        return axios.get(`api/admin/VoucherCards/Cards/GetCardInfoBySerialNumber?SerialNumber=${SerialNumber}`);
    },

    GetCardInfoByVoucherNumber(VoucherNumber) {
        return axios.get(`api/admin/VoucherCards/Cards/GetCardInfoByVoucherNumber?SerialNumber=${VoucherNumber}`);
    },


    //TryAttemp
    GetVoucherCardsTryAttemp(pageNo, pageSize, Search) {
        return axios.get(`api/admin/VoucherCards/TryAttemp/Get?pageNo=${pageNo}&pagesize=${pageSize}&Search=${Search}`);
    },



    //Chart
    GetVoucherCardsChart() {
        return axios.get(`api/admin/VoucherCards/Chart/Get`);
    },



    


    //Distributors
    GetDistributors(pageNo, pageSize, Search) {
        return axios.get(`api/admin/VoucherCards/Distributors/Get?pageNo=${pageNo}&pagesize=${pageSize}&Search=${Search}`);
    },

    GetAllDistributors() {
        return axios.get(`api/admin/VoucherCards/Distributors/GetAll`);
    },

    AddDistributors(bodyObject) {
        return axios.post('api/admin/VoucherCards/Distributors/Add', bodyObject);
    },

    EditDistributors(bodyObject) {
        return axios.post('api/admin/VoucherCards/Distributors/Edit', bodyObject);
    },

    ResetPasswordDistributors(Id) {
        return axios.post(`api/admin/VoucherCards/${Id}/Distributors/ResetPassword`);
    },

    ChangeStatusDistributors(Id) {
        return axios.post(`api/admin/VoucherCards/${Id}/Distributors/ChangeStatus`);
    },

    DeleteDistributors(Id) {
        return axios.post(`api/admin/VoucherCards/${Id}/Distributors/Delete`);
    },




    ActivePackgeDistributors(bodyObject) {
        return axios.post('api/admin/VoucherCards/Distributors/ActivePackge', bodyObject);
    },

    GetDistributorsPackages(pageNo, pageSize) {
        return axios.get(`api/admin/VoucherCards/Distributors/Packages/Get?pageNo=${pageNo}&pagesize=${pageSize}`);
    },

    // ********************************| End Of VoucherCards |********************************












    // ********************************| Users |********************************
    GetUsers(pageNo, pageSize, Search) {
        return axios.get(`api/admin/Users/Get?pageNo=${pageNo}&pagesize=${pageSize}&Search=${Search}`);
    },

    GetUsersTransactions(pageNoT, pageSizeT, Id) {
        return axios.get(`api/admin/Users/GetTransactions?pageNo=${pageNoT}&pagesize=${pageSizeT}&Id=${Id}`);
    },

    GetAllUsers() {
        return axios.get(`api/admin/Users/GetAll`);
    },

    AddUsers(bodyObject) {
        return axios.post('api/admin/Users/Add', bodyObject);
    },

    EditUsers(bodyObject) {
        return axios.post('api/admin/Users/Edit', bodyObject);
    },

    ResetPasswordUsers(Id) {
        return axios.post(`api/admin/Users/${Id}/ResetPassword`);
    },

    ChangeStatusUsers(Id) {
        return axios.post(`api/admin/Users/${Id}/ChangeStatus`);
    },

    DeleteUsers(Id) {
        return axios.post(`api/admin/Users/${Id}/Delete`);
    },


    //USerProfile 
    ChangeProfilePicture(bodyObject) {
        return axios.post('api/admin/Users/Profile/ChangePicture', bodyObject);
    },

    ChangeProfileInfo(bodyObject) {
        return axios.post('api/admin/Users/Profile/ChangeInfo', bodyObject);
    },

    ChangeProfilePassword(bodyObject) {
        return axios.post('api/admin/Users/Profile/ChangePassword', bodyObject);
    },




    // ********************************| End Of Users |********************************




    
    
}